import Typography from '@mui/material/Typography';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { buildRoute, activities } from '@/routes';

import * as Styled from './Drawer.styled';

const Activities: React.FC = () => {
	const history = useHistory();

	return (
		<Styled.Button disableRipple onClick={() => history.push(buildRoute(activities, {}))}>
			<Typography color="textPrimary" variant="subtitle2">
				Activities
			</Typography>
		</Styled.Button>
	);
};

export default Activities;
